import React from 'react'
import { Divider } from 'antd'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { getHeaderSystemKeyByPath } from '@/utils/help'
import { ReactComponent as HeaderLogoIcon } from '@/assets/svg/zjylogo.svg'
import { ReactComponent as BlueHeaderLogoIcon } from '@/assets/svg/zjylogo-blue.svg'
import { ReactComponent as LogoTest } from '@/assets/svg/logo/logoTest.svg'
// 申厚润企业logo
import shenhouLogo from '@/assets/enterprises/shenhou/logo-shenhou.png'
import { ThemeTypeObj } from '@/config/theme'
import styles from './index.module.less'
import useGlobalStore from '@/store/useGlobalStore'
import { MenuEnum, SystemEnum, SystemTypeEnum } from '@/config/enum'

const systemKeyToModuleName: Record<string, string> = {
  [SystemTypeEnum.CMP_MASTERDATA]: MenuEnum.SYSTEM,
  [SystemTypeEnum.CMP_ACHIEVEMENT]: MenuEnum.XMYJ,
  [SystemTypeEnum.CMP_INDEX]: MenuEnum.ZJZB,
  [SystemTypeEnum.LJXT]: MenuEnum.LJXT,
  [SystemTypeEnum.ZXZY]: MenuEnum.ZXZY,
  [SystemTypeEnum.CMP_DOCS]: MenuEnum.ZLWD,
  [SystemTypeEnum.SHRY]: MenuEnum.SHRY,
}

/**
 * 获取当前企业标识
 * 支持通过环境变量 REACT_APP_ENTERPRISE 或 package.json 中的 config.enterprise 配置
 * 默认值为 'luban'
 */
export const getEnterprise = (): string => {
  // 优先使用环境变量
  if (process.env.REACT_APP_ENTERPRISE) {
    return process.env.REACT_APP_ENTERPRISE
  }

  // 尝试从 package.json 读取（需要在构建时注入）
  // @ts-ignore
  if (typeof window !== 'undefined' && (window as any).__ENTERPRISE__) {
    // @ts-ignore
    return (window as any).__ENTERPRISE__
  }

  // 默认返回 luban
  return 'luban'
}

interface RenderLogoProps {
  currentTheme: string
  currentEnterprise?: {
    logoUrl?: string
    nameCn?: string
    epid?: string
  }
  superAdminTenantId?: string
}

/**
 * 根据企业标识渲染不同的 Logo 区域（包括 logo、文字、企业名称等）
 */
export const renderLogo = ({ currentTheme, currentEnterprise, superAdminTenantId }: RenderLogoProps) => {
  const enterprise = getEnterprise()
  const location = useLocation()
  const { pathname } = location
  const findSystemKey = getHeaderSystemKeyByPath(pathname)
  const moduleNameKey = SystemTypeEnum[findSystemKey]
  const moduleName = systemKeyToModuleName[moduleNameKey] || ''
  // const {currentEnterprise} = useGlobalStore.getState()
  // console.log("globalCurrentEnterprise", globalCurrentEnterprise)
  console.log("currentEnterprise?.logoUrl", currentEnterprise?.logoUrl)
  // shenhou 企业的自定义渲染
  if (enterprise === 'shenhou') {
    return (
      <>
        <img src={shenhouLogo} alt="申厚" style={{ height: '47px' }} className={styles.logo} />
        {/* <span className={styles.title}>test</span> */}
      </>
    )
  }

  if (currentEnterprise?.logoUrl) {
    return (
      <>
        <img className={styles.logosass} title={currentEnterprise?.nameCn} src={currentEnterprise?.logoUrl} alt={currentEnterprise.nameCn} />
        {/* <span className={styles.title}>造价云</span> */}
        {superAdminTenantId === currentEnterprise?.epid ? (
          <div className={styles['enterprise_name']} style={{ color: '#F0993E' }}>
            {`${currentEnterprise?.nameCn} (超级空间)`}
          </div>
        ) : (
          <div className={styles['enterprise_name']}>{currentEnterprise?.nameCn}{moduleName && ` | ${moduleName}`}</div>
        )}
      </>
    )
  }

  // 默认 luban 企业的完整渲染逻辑（包括 logo、文字、企业名称等）
  return (
    <>
      {currentTheme === ThemeTypeObj.business ? <BlueHeaderLogoIcon /> : <HeaderLogoIcon />}
      {/* {currentTheme === ThemeTypeObj.business ? <LogoTest className={styles.title}/> : <LogoTest className={styles.title}/>}  */}


      <span className={styles.title}>造价云</span>
      {currentEnterprise?.nameCn ? (
        <>
          <Divider className={styles['header_divider']} type="vertical" />
          {superAdminTenantId === currentEnterprise?.epid ? (
            <div className={styles['enterprise_name']} style={{ color: '#F0993E' }}>
              {`${currentEnterprise?.nameCn} (超级空间)`}
            </div>
          ) : (
            <div className={styles['enterprise_name']}>{currentEnterprise?.nameCn}{moduleName && ` | ${moduleName}`}</div>
          )}
        </>
      ) : null}
    </>
  )
}
